import { useEffect, useState } from "react";
import cls from "./PartnerRequestModal.module.scss";

export default function PartnerRequestModal({
  isOpen,
  onClose,
  onSubmit,
  loading = false,
  availablePlayers = [],
}) {
  const [selectedPlayerNo, setSelectedPlayerNo] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setSelectedPlayerNo("");
      setError("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const hasAvailablePlayers = availablePlayers.length > 0;

  const handleSubmit = async (event) => {
    event.preventDefault();

    const normalized = selectedPlayerNo.trim();
    if (!normalized) {
      setError("Select one available player to send a partner request.");
      return;
    }

    setError("");
    const ok = await onSubmit?.({ targetPlayerNo: normalized });

    if (ok) {
      setSelectedPlayerNo("");
      onClose?.();
    }
  };

  return (
    <div className={cls.overlay} role="dialog" aria-modal="true">
      <div className={cls.backdrop} onClick={onClose} />

      <form className={cls.card} onSubmit={handleSubmit}>
        <div className={cls.cardGlow} />

        <div className={cls.head}>
          <p className={cls.eyebrow}>PARTNER FINDER</p>
          <h3 className={cls.title}>Find your partner</h3>
          <p className={cls.subtitle}>
            Select one single player to send your partner request.
          </p>
        </div>

        {hasAvailablePlayers ? (
          <div className={cls.optionsWrap}>
            {availablePlayers.map((player) => {
              const avatarUrl = player?.image?.url || "";
              const name = player?.displayName || "Unknown player";
              const playerNo = player?.playerNo || "--";
              const isSelected = selectedPlayerNo === String(playerNo);

              return (
                <button
                  key={player._id}
                  type="button"
                  className={`${cls.option} ${isSelected ? cls.optionSelected : ""}`}
                  onClick={() => {
                    setSelectedPlayerNo(String(playerNo));
                    setError("");
                  }}
                  disabled={loading}
                >
                  {avatarUrl ? (
                    <img src={avatarUrl} alt={name} className={cls.optionAvatar} />
                  ) : (
                    <div className={cls.optionFallback}>
                      {name.slice(0, 1).toUpperCase()}
                    </div>
                  )}

                  <div className={cls.optionText}>
                    <div className={cls.optionName}>{name}</div>
                    <div className={cls.optionNo}>Player #{playerNo}</div>
                  </div>
                </button>
              );
            })}
          </div>
        ) : (
          <div className={cls.empty}>No single players available right now.</div>
        )}

        {error ? <div className={cls.error}>{error}</div> : null}

        <div className={cls.buttonRow}>
          <button
            type="button"
            className={cls.secondaryButton}
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="submit"
            className={cls.primaryButton}
            disabled={loading || !hasAvailablePlayers}
          >
            {loading ? "Sending..." : "Send request"}
          </button>
        </div>
      </form>
    </div>
  );
}